export interface IAdUnitConfgiDTO {
    id_adunit: number;
    adunit_path?: string;
    div_id?: string;
    type: IAdUnitTypeDTO;
    bidders: {
        id_bidder: number;
        code_bidder: string;
        config?: Record<string, any>;
    }[];
}

export interface IConfigDTO {
    project: {
        id: number;
        hash: string;
        name: string;
    },
    config: {
        id: number;
        hash: string;
        name: string;
        cors_domains?: string[];
        domain: string;
        environment?: string;
        log_level?: 'log' | 'warn' | 'error';
        analytics: {
            enabled: boolean;
            sampling?: number;
        }
        hb_config: {
            bid_timeout?: number;
            failsafe_timeout?: number;
            platforms_enabled: {
                id: number;
                code: string;
                config?: Record<string, any>;
            }[];
            bidders_enabled: {
                id: number;
                code: string;
                config?: {
                    multiplier?: number;
                    config?: Record<string, any>;
                }
            }[];
            adunits: IAdUnitConfgiDTO[];
        };
    }
}

export type IAdUnitTypes = 'video' | 'banner';

export interface IAdUnitTypeDTO {
    banner?: {
        sizes?: number[][];
    };
    video?: {
        position?: VideoAdUnitPosition;
        context?: VideoAdUnitContext;
        placement?: VideoAdUnitPlacement;
        player_size?: number[];
        api?: number[];
        mimes?: string[];
        protocols?: number[];
        playback_method?: number[];
        duration?: {
            min?: number;
            max?: number;
        };
        size?: {
            width?: number;
            height?: number;
        }
        start_delay?: number;
        linearity?: number;
        bitrate?: {
            min?: number;
            max?: number;
        }
    };
}

export enum VideoAdUnitPosition {
    UNKNOWN = 'unknown',
    ABOVE_THE_FOLD = 'above_the_fold',
    BELOW_THE_FOLD = 'below_the_fold',
    HEADER = 'header',
    FOOTER = 'footer',
    SIDEBAR = 'sidebar',
    FULLSCREEN = 'fullscreen',
}

export enum VideoAdUnitContext {
    INSTREAM = 'instream',
    OUTSTREAM = 'outstream',
}

export enum VideoAdUnitPlacement {
    IN_STREAM = 'in_stream',
    IN_BANNER = 'in_banner',
    IN_ARTICLE = 'in_article',
    IN_FEED = 'in_feed',
    INETRSITIAL = 'interstitial',
}

export interface IBidEventDTO {
    id: string;
    project_hash: string;
    config_hash: string;
    id_platform: number;
    id_auction: string;
    status: BidStatus;
    adunit_path: string;
    adunit_type: IAdUnitTypes;
    bidder: string;
    adunit_div_id: string;
    data: IBidEventDataDTO;
    timestamp: number;
}

export type IBidEventDataDTO = Record<string, any> & {
    ad_id?: string;
    cpm?: number;
    original_cpm?: number;
    time_to_respond?: number;
    timeout?: number;
    reason?: string;
};

export enum BidStatus {
    REQUESTED = 'requested',
    RECEIVED = 'received',
    REJECTED = 'rejected',
    NOBID = 'nobid',
    WIN = 'win',
    TIMEDOUT = 'timedout'
}

export interface ILoaderQuery {
    project: string;
    config: string;
}
